import classNames from 'classnames'
import PencilIcon from 'mdi-react/PencilIcon'
import React, { Suspense } from 'react'
import { Deal } from 'scenes/Dashboard/data/deals/types'
import DealIsAFit from 'scenes/Dashboard/scenes/DealManager/components/DealCard/DealSearchFunction/DealIsAFit.component'
import { makeStyles } from 'tss-react/mui'
import { EditionViews, useEdition } from 'utils-next/hooks'
import { ExtendableStyles } from 'utils-next/types'

import { CircularProgress, IconButton, Theme, Typography } from '@mui/material'

import { useDealHandlers } from '../DealCard.container'
import { DealSearchFunctionEdit } from './DealSearchFunctionEdit.component'

export type DealSearchFunctionProps = ExtendableStyles & {
  deal: Deal
}

export function DealSearchFunction({ className, deal, ...otherProps }: DealSearchFunctionProps) {
  const { classes } = useStyles()
  const { view, enableEdition, disableEdition } = useEdition(EditionViews.view)
  const { updateDealData } = useDealHandlers(deal.id, disableEdition)
  return (
    <div className={classNames(className, classes.searchFunctionContainer)} {...otherProps}>
      {view === EditionViews.view && (
        <div className={classes.flexCol}>
          <div>
            <IconButton className={classes.editButton} onClick={enableEdition}>
              <PencilIcon />
            </IconButton>

            <Typography className={classes.title} variant="body1" gutterBottom>
              Fit reason
            </Typography>
            {deal.fitReason ? <DealIsAFit fitReason={deal.fitReason} /> : <span>N/A</span>}
          </div>
        </div>
      )}

      {view === EditionViews.edit && (
        <Suspense fallback={<CircularProgress />}>
          <DealSearchFunctionEdit deal={deal} onSubmit={updateDealData} />
        </Suspense>
      )}
    </div>
  )
}

const useStyles = makeStyles()(({ typography, spacing }: Theme) => ({
  searchFunctionContainer: {
    position: 'relative',
    borderRadius: '10px',
    border: '2px solid rgba(0,0,0,0.1)',
    padding: '10px',
  },
  editButton: {
    position: 'absolute',
    right: spacing(-1),
    top: spacing(-1),
    padding: spacing(2),
  },
  title: {
    fontWeight: typography.fontWeightBold,
  },
  infoSection: {
    marginBottom: spacing(2),
  },
  flexCol: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(2),
  },
}))
